import React, { useState } from 'react';
import '../styles/pages/CardsPrinting.css';
import FlexPortfolio from './FlexPortfolio';
import FlexServicesSection from '../components/FlexServicesSection';
import HeroSection from '../components/HeroSection';

const CardsPrinting = () => {
  const [activeSection, setActiveSection] = useState(1);

  const cardsTypes = [
    {
      id: 1,
      title: "Wedding Card",
      icon: "💒",
      description: "Elegant wedding invitation cards with beautiful multicolor designs. Perfect for your special day celebrations.",
      features: [
        "Custom wedding designs",
        "High-quality cardstock",
        "Multicolor printing",
        "Personalized messages",
        "Envelope included",
        "Bulk discounts available"
      ],
      specifications: {
        material: "Premium cardstock, 300 GSM",
        thickness: "300 GSM",
        width: "5x7 inches, custom sizes",
        durability: "Long-lasting quality",
        applications: "Wedding invitations, RSVPs"
      },
      image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=500&h=350&fit=crop", // Wedding card image
      color: "#ec4899",
      bestFor: ["Wedding invitations", "Engagement announcements", "Reception cards", "Thank you cards"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1519741497674-611481863552?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1519741497674-611481863552?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1519741497674-611481863552?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1519741497674-611481863552?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 2,
      title: "Function Card",
      icon: "🎉",
      description: "Vibrant function cards for birthdays, anniversaries, and special events. Custom designs that capture the celebration spirit.",
      features: [
        "Event-specific designs",
        "Colorful illustrations",
        "Personalized text",
        "Quality printing",
        "Various sizes",
        "Quick turnaround"
      ],
      specifications: {
        material: "Glossy cardstock, 250 GSM",
        thickness: "250 GSM",
        width: "4x6 inches, custom",
        durability: "Durable for events",
        applications: "Birthdays, anniversaries, parties"
      },
      image: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=500&h=350&fit=crop", // Function card image
      color: "#f59e0b",
      bestFor: ["Birthday parties", "Anniversary celebrations", "Baby showers", "Graduation events"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 3,
      title: "ID Cards",
      icon: "🆔",
      description: "Professional ID cards with secure printing and lamination. Perfect for employee badges, student IDs, and membership cards.",
      features: [
        "Secure printing",
        "Lamination options",
        "Photo integration",
        "Barcode/QR codes",
        "Custom layouts",
        "Bulk production"
      ],
      specifications: {
        material: "PVC cards, laminated",
        thickness: "30 mil PVC",
        width: "Standard ID size",
        durability: "Waterproof, scratch-resistant",
        applications: "Employee IDs, student cards"
      },
      image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=500&h=350&fit=crop", // ID card image
      color: "#3b82f6",
      bestFor: ["Employee badges", "Student IDs", "Membership cards", "Access cards"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 4,
      title: "Visiting Cards",
      icon: "📇",
      description: "Professional visiting cards that make a lasting impression. Custom designs with your contact information and branding.",
      features: [
        "Custom branding",
        "Contact information",
        "Quality cardstock",
        "Various finishes",
        "Bulk printing",
        "Design consultation"
      ],
      specifications: {
        material: "Premium cardstock, 300 GSM",
        thickness: "300 GSM",
        width: "3.5x2 inches",
        durability: "Professional quality",
        applications: "Business networking, contacts"
      },
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=500&h=350&fit=crop", // Visiting card image
      color: "#10b981",
      bestFor: ["Business professionals", "Entrepreneurs", "Service providers", "Corporate executives"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
        ]
      }
    }
  ];

  return (
    <div className="cards-printing-page">
      <HeroSection
        heroTitle="Cards Printing Services"
        heroSubtitle="Create memorable impressions with our premium card printing services. From wedding invitations to professional ID cards, we deliver quality and elegance."
        onExploreClick={() => {
          const servicesSection = document.querySelector('.services-section');
          if (servicesSection) {
            servicesSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        onGetQuoteClick={() => {
          const contactSection = document.getElementById('contact');
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      />

      <FlexServicesSection
        flexTypes={cardsTypes}
        title="Our Premium Cards Printing Solutions"
        subtitle="Create memorable impressions with our premium card printing services. From wedding invitations to professional ID cards, we deliver quality and elegance."
      />

      <FlexPortfolio
        activeSection={activeSection}
        portfolioData={cardsTypes.map(cardsType => ({
          id: cardsType.id,
          title: cardsType.title,
          icon: cardsType.icon,
          gallery: cardsType.portfolio?.gallery || []
        }))}
        title="Our Cards Printing Portfolio"
        subtitle="Explore our premium cards printing services and see the quality that sets us apart"
      />
    </div>
  );
};

export default CardsPrinting;
